// Frete é o único valor monetário do pedido gravado em reais (float): o checkout
// do cliente e o wizard do admin salvam `shipping` assim, enquanto cardsValue,
// insurance e finalPrice ficam em centavos.
export const shippingToCents = (shipping) => Math.round((Number(shipping) || 0) * 100);

// Quanto do que o cliente pagou sobrou para a graduação. Em pedido com cupom o
// desconto incide sobre o total, então o valor aqui já sai líquido.
export const getGradingValue = (product) => {
    if (product?.finalPrice === undefined || product?.finalPrice === null) {
        return null;
    }
    return product.finalPrice - (product.insurance || 0) - shippingToCents(product.shipping);
};
